export const ROUTE_PATH = {
    HOME: '/',
    LOGIN: '/login',
    EXPLORE: '/explore',
    MY_CARS: '/my-cars',
    ORDERS: '/orders',
    NOTIFICATIONS: '/notifications',
    SMART_REQUIREMENT: '/smart-requirement',
    WATCH_LIST: '/watch-list',
    ACCOUNT: '/account',
    AUCTION_DETAILS: '/auction-details',
    DEALER_AUCTION_DETAILS: '/:step/auction-details',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    FAQ: '/faqs'
};
